/**
 * @desc sku-eip审批前保存
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.Response;
export function request(
  body: defs.basics.PlmSkuApprovalRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/product/sku/approvalBeforeSave`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
